import { Image } from 'components/generic/HomePageComponents'
import Modal from 'components/generic/Modal'
import { useState } from 'react'
import { Container, Photo } from './Photos.style'

type Photo = {
  largeUrl: string
  mediumUrl: string
}

type PhotoProps = {
  photos: Array<Photo>
}

const Photos = ({ photos }: PhotoProps) => {
  const [showModal, setShowModal] = useState(false)
  const [selectedPhotoUrl, setSelectedPhotoUrl] = useState(null)

  const onPhotoClicked = (url: string) => {
    setSelectedPhotoUrl(url)
    setShowModal(true)
  }
  const onCloseModal = () => {
    setSelectedPhotoUrl('')
    setShowModal(false)
  }

  return (
    <Container>
      {photos.map((photo, i) => (
        <Photo
          key={i}
          title='Photo'
          src={photo.mediumUrl}
          height={100}
          width={100}
          onClick={() => onPhotoClicked(photo.largeUrl)}
        />
      ))}
      <Modal onCloseModal={onCloseModal} showModal={showModal} shouldCloseOnEsc={true}>
        <Image
          width={{ _: '275px', tablet: '500px', desktop: '500px' }}
          height='auto'
          borderRadius='5px'
          src={selectedPhotoUrl}
        />
      </Modal>
    </Container>
  )
}

export default Photos
